import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchTermPaymentRecords } from './report.action';

@Injectable({ providedIn: 'root' })
export class TermPaymentTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                id: '',
                debtor_name: '',
                club_name: null,
                outstanding_with_fee: '',
                is_paid: null,
                report_categories_name: null,
                season_name: '',
                member_number: '',
                debtor_phone: '',
                debtor_phone_other: '',
                team: '',
                missed_payments: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'season_name';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubs = [];
    categories = [];
   

    columns = [
                { prop: 'id', name: 'REPORTS.dossier-id', sortable: true, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'dossier_categories_name', name: 'REPORTS.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name", widthSet: 150},
                { prop: 'club_name', name: 'REPORTS.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name", widthSet: 180},
                { prop: 'member_number', name: 'REPORTS.member-number', sortable: true, hasFilter: true, filter: "input", widthSet: 125},
                { prop: 'debtor_name', name: 'REPORTS.debtor-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'debtor_phone', name: 'REPORTS.phone', sortable: true, hasFilter: true, filter: "input", widthSet: 120},
                { prop: 'debtor_phone_other', name: 'REPORTS.secondary-phone', sortable: true, hasFilter: true, filter: "input", widthSet: 130},
                { prop: 'team', name: 'REPORTS.team', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'missed_payments', name: 'REPORTS.missed-payments', sortable: true, hasFilter: true, filter: "input", widthSet: 80},
                { prop: 'outstanding_with_fee', name: 'REPORTS.outstanding', sortable: true, hasFilter: true, filter: "input", widthSet: 110}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchTermPaymentRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
            created_at: '',
            id: '',
            debtor_name: '',
            club_name: null,
            outstanding_with_fee: '',
            is_paid: null,
            report_categories_name: null,
            season_name: '',
            member_number: '',
            debtor_phone: '',
            debtor_phone_other: '',
            team: '',
            missed_payments: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}